import getAuthData from "core/helpers/auth/getAuthData";

const isAuthenticated = () => {
	const authData = getAuthData();

	return Boolean(authData);
};

export default isAuthenticated;